/* xp-coupon.js v2.1 (0907 修复：券码有效性以回读 /cart.js 的 discount_codes[code].applicable 为准；无效码不持久化；具体原因不被通用文案覆盖；/cart 页 reload 后回放反馈；隐藏 discount 字段只带生效码；429 不报成功)
 * xp-coupon.js v2 — XPlamps discount code UX (ported from Rynix claim-coupon architecture)
 * 1. PDP claim cards: copy code + persist + apply to the cart.
 * 2. Cart drawer: inject discount input / applied breakdown (original subtotal,
 *    code line, savings) above the total.
 * 3. Cart page + (optional) add-to-cart popup: same box, same code path.
 *
 * v2 (post code-review) semantics, all verified live against Shopify:
 * - POST /cart/update.js {"discount": CODE} applies a code and REPLACES the
 *   session's code set; {"discount": ""} truly removes all codes. The old
 *   /discount/CODE deeplink ACCUMULATES codes and nothing can remove them
 *   client-side, so v2 uses update.js exclusively (also avoids the full-page
 *   HTML download the deeplink redirect caused).
 * - Because update.js replaces the set, applying a code that turns out not to
 *   apply (e.g. XP2027 under its $5,000 minimum) would silently drop a working
 *   one — so apply() restores the previous code when the new one is inapplicable.
 * - The applied label is read from cart.discount_codes (the code Shopify says
 *   is applicable), never from local storage, so ad-deeplink codes (XP20/XP30)
 *   are attributed correctly.
 * - A global jQuery ajaxError net covers the theme's silent failure paths:
 *   nuranium.js's remove handler has no error callback and its add-to-cart
 *   error branch mislabels any failure (incl. 429 bot challenges) as
 *   "Sold out" — we toast, resync the drawer from the server, and restore the
 *   button text instead.
 */
(function () {
  'use strict';

  var LS_KEY = 'xpClaimedCode';
  var LS_TOMBSTONE = 'xpCodeCleared'; // set on remove so stray theme cookies can't resurrect a code
  var COOKIE = 'discountCode'; // same cookie the stock theme's drawer tab uses

  /* ---------- persistence ---------- */
  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 864e5);
    document.cookie = name + '=' + encodeURIComponent(value) + ';expires=' + d.toUTCString() + ';path=/';
  }
  function getCookie(name) {
    var m = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    if (!m) return '';
    try { return decodeURIComponent(m.pop()); } catch (e) { return ''; }
  }
  function savedCode() {
    var tomb = '';
    try { tomb = localStorage.getItem(LS_TOMBSTONE) || ''; } catch (e) {}
    var c = '';
    try { c = localStorage.getItem(LS_KEY) || ''; } catch (e) {}
    if (!c && !tomb) c = getCookie(COOKIE); // theme drawer-tab interop; blocked by tombstone after remove
    return (c || '').trim();
  }
  function persistCode(code) {
    try {
      localStorage.setItem(LS_KEY, code);
      localStorage.removeItem(LS_TOMBSTONE);
    } catch (e) {}
    setCookie(COOKIE, code, 30);
    // 0907 修复：隐藏 discount 字段改由 syncHiddenDiscount 按购物车真实 applicable 码同步，这里不再直写（原来会把无效/失效码带进结账）
  }
  function clearCode() {
    try {
      localStorage.removeItem(LS_KEY);
      localStorage.setItem(LS_TOMBSTONE, '1');
    } catch (e) {}
    setCookie(COOKIE, '', -1);
    // best-effort: also expire a path-less variant the theme's $.cookie may have written
    document.cookie = COOKIE + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
    var hidden = document.querySelector('.js-form-discount');
    if (hidden) hidden.value = '';
  }

  /* ---------- cart API ---------- */
  var _cartCache = { t: 0, data: null };
  function getCart(fresh) {
    var now = Date.now();
    if (!fresh && _cartCache.data && now - _cartCache.t < 1200) {
      return Promise.resolve(_cartCache.data);
    }
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('cart.js ' + r.status); return r.json(); })
      .then(function (c) { _cartCache = { t: Date.now(), data: c }; return c; })
      .catch(function () { return null; });
  }
  function setCartDiscount(code) {
    // update.js semantics (verified live): replaces the whole code set; '' clears it.
    var opts = {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: code }),
    };
    try { opts.signal = AbortSignal.timeout(10000); } catch (e) {}
    return fetch('/cart/update.js', opts).then(function (r) {
      if (!r.ok) throw new Error('update.js ' + r.status);
      return getCart(true);
    });
  }
  // 0907 修复：隐藏 discount 字段只带 applicable===true 的码（原来取 discount_codes[0]，可能是失效码）；
  // 没有生效码时 syncHiddenDiscount 会摘掉 name 属性，不往结账带垃圾码，也不会用空值清掉 session 码
  function sessionCode(cart) {
    if (!cart) return '';
    var codes = cart.discount_codes || [];
    for (var i = 0; i < codes.length; i++) {
      if (codes[i].applicable === true) return codes[i].code;
    }
    return '';
  }
  function syncHiddenDiscount(cart) {
    var hidden = document.querySelector('.js-form-discount');
    if (!hidden) return;
    var code = sessionCode(cart);
    if (code) {
      hidden.value = code;
      hidden.setAttribute('name', 'discount');
    } else {
      hidden.value = '';
      hidden.removeAttribute('name'); // 空值提交会清码,干脆不提交该字段
    }
  }
  function appliedCodeName(cart) {
    if (!cart) return '';
    var codes = cart.discount_codes || [];
    for (var i = 0; i < codes.length; i++) {
      if (codes[i].applicable) return codes[i].code;
    }
    var apps = cart.cart_level_discount_applications || [];
    if (apps.length && apps[0].title) return apps[0].title;
    return '';
  }
  // 0907 修复：成功判据改为回读 /cart.js 后比对 discount_codes 里有没有「刚输入的这个码」且 applicable===true
  // （原来只看 total_discount>0，一旦后台开自动折扣任何乱码都会被报成功）。
  // 返回 state：applied=生效 / pending=空车暂无法判定 / ineligible=本店真码但不满足条件 / invalid=不存在
  function codeState(cart, code) {
    var want = (code || '').trim().toUpperCase();
    var codes = (cart && cart.discount_codes) || [];
    var entry = null;
    for (var i = 0; i < codes.length; i++) {
      if ((codes[i].code || '').toUpperCase() === want) { entry = codes[i]; break; }
    }
    if (!entry) return 'invalid';
    if (entry.applicable === true) return 'applied';
    if (!cart.item_count) return 'pending';
    if (KNOWN_CODES.indexOf(want) !== -1) return 'ineligible';
    return 'invalid'; // Shopify 对不存在的码同样回 applicable:false（0907 实测），只能靠本店已知码表区分
  }
  // Apply `code`; if it doesn't produce a discount but the previous state did,
  // restore the previous code instead of leaving the customer worse off.
  function applyWithGuard(code) {
    return getCart(true).then(function (before) {
      var prevCode = before ? appliedCodeName(before) : '';
      var prevDiscount = before ? before.total_discount : 0;
      return setCartDiscount(code).then(function (after) {
        if (!after) throw new Error('cart.js unavailable'); // 0907 修复：回读失败不能当成功，走 catch 报「Could not apply」
        var state = codeState(after, code);
        if (state === 'applied') return { cart: after, applied: true, kept: '', state: state };
        if (prevDiscount > 0 && prevCode && prevCode.toUpperCase() !== (code || '').trim().toUpperCase()) {
          return setCartDiscount(prevCode).then(function (restored) {
            return { cart: restored || after, applied: false, kept: prevCode, state: state };
          });
        }
        if (state === 'invalid') {
          // 0907 修复：不存在的码不留在购物车会话里（否则会一路带到结账）
          return setCartDiscount('').then(function (cleared) {
            return { cart: cleared || after, applied: false, kept: '', state: state };
          }, function () {
            return { cart: after, applied: false, kept: '', state: state };
          });
        }
        return { cart: after, applied: false, kept: '', state: state };
      });
    });
  }
  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text).catch(function () { legacyCopy(text); });
    }
    legacyCopy(text);
    return Promise.resolve();
  }
  function legacyCopy(text) {
    var t = document.createElement('textarea');
    t.value = text;
    t.style.position = 'fixed';
    t.style.opacity = '0';
    document.body.appendChild(t);
    t.select();
    try { document.execCommand('copy'); } catch (e) {}
    t.remove();
  }
  var KNOWN_CODES = ['XP2026', 'XP2027', 'XP20', 'XP30']; // 0907 经 Admin API 核实四个码均存在且 ACTIVE
  // 0907 修复：真码不满足条件时给具体原因（门槛/品类），不再用「will apply at checkout」的肯定句
  function ineligibleReason(code, cart) {
    var up = (code || '').toUpperCase();
    if (up === 'XP2027' || up === 'XP30') {
      var otp = cart && cart.original_total_price;
      var need = 500000 - (otp || 0);
      return 'Code ' + up + ' needs an order of $5,000 or more' + (otp && need > 0 ? ' — add ' + fmtMoney(need) + ' more to use it.' : '.');
    }
    if (up === 'XP2026') return "Code XP2026 doesn't cover the items in your cart (table & floor lamps are excluded).";
    return 'Code ' + code + " doesn't apply to the items in your cart.";
  }
  function pendingText(code) {
    return 'Code ' + code + ' saved — it will be checked and applied once you add items to your cart.';
  }
  function hintForSaved(code, cart) {
    var up = (code || '').toUpperCase();
    if (cart && !cart.item_count) return pendingText(code); // 0907 修复：空车说「加购后自动抵扣」而不是「结账时会生效」
    if (KNOWN_CODES.indexOf(up) !== -1) return ineligibleReason(code, cart);
    return 'Code ' + code + ' saved — double-check the spelling if you expected an instant discount.';
  }
  // 0907 修复：把 applyWithGuard 的结果翻译成唯一一条文案（具体原因优先，不再叠加通用文案）
  function describeResult(code, res) {
    var cart = res.cart || {};
    if (res.applied) return { text: 'Code ' + code + ' applied — you save ' + fmtMoney(cart.total_discount) + '.', err: false };
    var text;
    if (res.state === 'pending') text = pendingText(code);
    else if (res.state === 'ineligible') text = ineligibleReason(code, cart);
    else text = "That code isn't valid — please check the spelling and try again.";
    if (res.kept) text += ' Kept ' + res.kept + ' active.';
    return { text: text, err: res.state !== 'pending' };
  }
  // 0907 修复：应用结果统一落地——生效/待生效/真码才持久化；不存在的码绝不写 localStorage/cookie；
  // 具体原因记在 _lastMsg，盒子重绘（refreshDrawer/reload）后继续显示，不会被通用文案覆盖
  var _lastMsg = null;
  var _lastToast = '';
  var SS_MSG = 'xpCartMsg';
  function settle(code, res) {
    var d = describeResult(code, res);
    if (res.applied) {
      _lastMsg = null;
      persistCode(code);
    } else {
      _lastMsg = { code: code, text: d.text, err: d.err, state: res.state };
      if (res.kept) persistCode(res.kept);
      else if (res.state !== 'invalid') persistCode(code);
    }
    syncHiddenDiscount(res.cart);
    return d;
  }
  function currentMsg(cart, activeCode) {
    var m = _lastMsg;
    if (!m) return null;
    if (m.state === 'pending' && cart && cart.item_count > 0) return null; // 空车时存的「待生效」已过时
    if (activeCode && m.code.toUpperCase() === activeCode.toUpperCase()) return null;
    return m;
  }
  function fmtMoney(cents) {
    try { return Shopify.formatMoney(cents, window.theme.moneyFormat); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  /* ---------- toast ---------- */
  function toast(msg) {
    var el = document.getElementById('xpToast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'xpToast';
      document.body.appendChild(el);
    }
    el.textContent = msg;
    _lastToast = msg; // 0907 修复：/cart 页 reload 前后回放用
    el.classList.add('is-visible');
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('is-visible'); }, 3600);
  }

  /* ---------- styles ---------- */
  var css = '' +
    '#xpToast{position:fixed;left:50%;bottom:32px;transform:translate(-50%,16px);z-index:99999;' +
      'background:#181818;color:#fff;font-size:13px;letter-spacing:.04em;padding:12px 20px;border-radius:3px;' +
      'opacity:0;pointer-events:none;transition:opacity .25s ease,transform .25s ease;max-width:90vw;text-align:center}' +
    '#xpToast.is-visible{opacity:1;transform:translate(-50%,0)}' +
    '.xp-dc{margin:0 0 14px;font-size:13px}' +
    '.xp-dc__row{display:flex;gap:8px}' +
    '.xp-dc__row input{flex:1;min-width:0;height:38px;padding:0 12px;border:1px solid #d9d9d9;border-radius:3px;' +
      'font-size:13px;letter-spacing:.06em;text-transform:uppercase;background:#fff}' +
    '.xp-dc__row input:focus{outline:none;border-color:#181818}' +
    '.xp-dc__row button{flex-shrink:0;height:38px;padding:0 16px;font-size:11px;font-weight:700;' +
      'letter-spacing:.1em;text-transform:uppercase;color:#fff;background:#181818;border:1px solid #181818;' +
      'border-radius:3px;cursor:pointer}' +
    '.xp-dc__row button:disabled{opacity:.5;cursor:wait}' +
    '.xp-dc__hint{margin-top:6px;font-size:12px;color:#777}' +
    '.xp-dc__summary{padding:10px 12px;background:#f3faf4;border:1px dashed #3d9950;border-radius:3px}' +
    '.xp-dc__line{display:flex;align-items:center;justify-content:space-between;gap:10px;font-size:13px;color:#181818}' +
    '.xp-dc__line+.xp-dc__line{margin-top:6px}' +
    '.xp-dc__orig{color:#999}' +
    '.xp-dc__orig s{text-decoration-color:#c33}' +
    '.xp-dc__line--disc{color:#2e7d3d}' +
    '.xp-dc__line--disc strong{letter-spacing:.08em}' +
    '.xp-dc__save{font-weight:700}' +
    '.xp-dc__remove{border:0;background:none;color:#2e7d3d;cursor:pointer;font-size:14px;line-height:1;padding:2px 6px;vertical-align:middle}' +
    '.xp-dc__remove:disabled{opacity:.4;cursor:wait}' +
    '.xp-dc__label{display:block;margin-bottom:6px;font-size:11px;font-weight:700;letter-spacing:.1em;' +
      'text-transform:uppercase;color:#181818}' +
    /* theme bug: cart.json.liquid used to mislabel total_discount as a second "Total" row */
    '.ajaxcart__footer > .total{display:none}' +
    '.ajaxcart__footer .xp-dc{margin:0 0 12px}' +
    '.cart__layout_right .xp-dc{margin:14px 0}' +
    '.xp-dc-slot .xp-dc{margin:0 0 18px}';
  var styleTag = document.createElement('style');
  styleTag.textContent = css;
  document.head.appendChild(styleTag);

  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- shared discount box ---------- */
  function buildBox(cart, opts) {
    var box = document.createElement('div');
    box.className = 'xp-dc';
    var applied = cart && cart.total_discount > 0;

    if (applied) {
      var realCode = appliedCodeName(cart);
      var removable = !!realCode; // 无码折扣(自动折扣)没有可移除的码
      if (!realCode) realCode = savedCode();
      var original = cart.original_total_price || (cart.total_price + cart.total_discount);
      box.innerHTML =
        '<div class="xp-dc__summary">' +
          '<div class="xp-dc__line">' +
            '<span>Subtotal</span>' +
            '<span class="xp-dc__orig"><s>' + fmtMoney(original) + '</s></span>' +
          '</div>' +
          '<div class="xp-dc__line xp-dc__line--disc">' +
            '<span>Code <strong>' + escapeHtml(realCode || 'discount') + '</strong>' +
              (removable ? '<button type="button" class="xp-dc__remove" aria-label="Remove discount">&#10005;</button>' : '') + '</span>' +
            '<span class="xp-dc__save">&minus;' + fmtMoney(cart.total_discount) + '</span>' +
          '</div>' +
        '</div>' +
        '<div class="xp-dc__row" style="margin-top:10px">' +
          '<input type="text" placeholder="Try another code" autocomplete="off">' +
          '<button type="button">Apply</button>' +
        '</div>' +
        '<div class="xp-dc__hint" hidden></div>';
      var removeBtn = box.querySelector('.xp-dc__remove');
      if (removeBtn) removeBtn.addEventListener('click', function () {
        var btn = this;
        btn.disabled = true;
        setCartDiscount('').then(function () {
          _lastMsg = null; // 0907 修复
          clearCode();
          toast('Discount removed.');
          if (opts && opts.onChange) opts.onChange();
        }).catch(function () {
          btn.disabled = false;
          toast('Connection hiccup — please try again.');
        });
      });
      var swInput = box.querySelector('.xp-dc__row input');
      var swBtn = box.querySelector('.xp-dc__row button');
      var swHint = box.querySelector('.xp-dc__hint');
      var swMsg = currentMsg(cart, realCode); // 0907 修复：重绘后继续显示上一次的具体原因
      if (swMsg) {
        swInput.value = swMsg.code;
        swHint.hidden = false;
        swHint.textContent = swMsg.text;
        swHint.setAttribute('data-xp-msg', swMsg.err ? 'error' : 'info');
      }
      function doSwitch() {
        var val = (swInput.value || '').trim();
        if (!val) return;
        swBtn.disabled = true;
        applyWithGuard(val).then(function (res) {
          var d = settle(val, res); // 0907 修复：只显示具体原因，不再叠加通用文案；无效码不持久化
          swBtn.disabled = false;
          if (!res.applied) {
            swHint.hidden = false;
            swHint.textContent = d.text;
            swHint.setAttribute('data-xp-msg', d.err ? 'error' : 'info');
          }
          toast(d.text);
          if (opts && opts.onChange) opts.onChange();
        }).catch(function () {
          swBtn.disabled = false;
          toast('Could not apply the code — please try again.'); // 0907 修复：429/网络错误不报成功
        });
      }
      if (swBtn) swBtn.addEventListener('click', doSwitch);
      if (swInput) swInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); doSwitch(); }
      });
    } else {
      var code = savedCode();
      box.innerHTML =
        '<span class="xp-dc__label">Discount code</span>' +
        '<div class="xp-dc__row">' +
          '<input type="text" placeholder="Enter code" autocomplete="off" value="' + escapeHtml(code) + '">' +
          '<button type="button">Apply</button>' +
        '</div>' +
        '<div class="xp-dc__hint" hidden></div>';
      var input = box.querySelector('input');
      var btn = box.querySelector('button');
      var hint = box.querySelector('.xp-dc__hint');
      var msg = currentMsg(cart, '');
      if (msg) {
        // 0907 修复：重绘后保留具体原因（原来硬编码「it will apply to eligible orders at checkout」把无效/门槛提示都盖掉了）
        input.value = msg.code;
        hint.hidden = false;
        hint.textContent = msg.text;
        hint.setAttribute('data-xp-msg', msg.err ? 'error' : 'info');
      } else if (code) {
        hint.hidden = false;
        hint.textContent = hintForSaved(code, cart);
        hint.setAttribute('data-xp-msg', 'info');
      }
      function doApply() {
        var val = (input.value || '').trim();
        if (!val) return;
        btn.disabled = true;
        applyWithGuard(val).then(function (res) {
          var d = settle(val, res); // 0907 修复：只显示具体原因；无效码不持久化、不写 cookie
          btn.disabled = false;
          if (!res.applied) {
            hint.hidden = false;
            hint.textContent = d.text;
            hint.setAttribute('data-xp-msg', d.err ? 'error' : 'info');
          }
          toast(d.text);
          if (opts && opts.onChange) opts.onChange();
        }).catch(function () {
          btn.disabled = false;
          toast('Could not apply the code — please try again.'); // 0907 修复：429/网络错误不报成功
        });
      }
      btn.addEventListener('click', doApply);
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); doApply(); }
      });
    }
    return box;
  }

  /* ---------- cart drawer ---------- */
  var _lastResync = 0;
  function resyncDrawer() {
    var now = Date.now();
    if (now - _lastResync < 4000) return;
    _lastResync = now;
    var info = document.getElementById('cart-info');
    if (!info) return;
    fetch('/cart?view=json', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('view=json ' + r.status); return r.text(); })
      .then(function (html) {
        info.innerHTML = html;
        getCart(true).then(function (c) {
          if (!c) return;
          var counts = document.querySelectorAll('.CartCount, #CartCountCavas');
          counts.forEach(function (el) { el.textContent = c.item_count; });
          var headerTotal = document.getElementById('header-cart-total');
          if (headerTotal) headerTotal.innerHTML = fmtMoney(c.total_price);
        });
      })
      .catch(function () {});
  }
  function enhanceDrawer() {
    var footer = document.querySelector('#cart-info .ajaxcart__footer');
    if (!footer || footer.querySelector('.xp-dc')) return;
    getCart(true).then(function (cart) {
      if (!cart) { if ((window.__xpRetryD = (window.__xpRetryD || 0) + 1) <= 5) setTimeout(enhanceDrawer, 4000); return; }
      if (!footer.isConnected || footer.querySelector('.xp-dc')) return;
      var box = buildBox(cart, { onChange: refreshDrawer });
      footer.insertBefore(box, footer.firstChild);
      syncHiddenDiscount(cart);
      // self-heal: if the rendered drawer disagrees with the server cart
      // (stale async overwrite in the theme), resync from the server
      var rows = document.querySelectorAll('#cart-info .ajaxcart__product').length;
      if (rows !== cart.items.length) resyncDrawer();
    });
  }
  function refreshDrawer() {
    getCart(true).then(function (cart) {
      if (!cart) return;
      var footer = document.querySelector('#cart-info .ajaxcart__footer');
      if (!footer) return;
      var price = footer.querySelector('.subtotal .price-st');
      if (price) price.innerHTML = fmtMoney(cart.total_price);
      var old = footer.querySelector('.xp-dc');
      if (old) old.remove();
      footer.insertBefore(buildBox(cart, { onChange: refreshDrawer }), footer.firstChild);
      syncHiddenDiscount(cart);
    });
  }
  var cartInfo = document.getElementById('cart-info');
  if (cartInfo) {
    new MutationObserver(function () { enhanceDrawer(); }).observe(cartInfo, { childList: true });
    enhanceDrawer();
  }

  /* ---------- add-to-cart popup (only when the theme setting uses it) ---------- */
  function enhancePopup() {
    var slot = document.querySelector('.xp-dc-slot');
    if (!slot || slot.querySelector('.xp-dc')) return;
    getCart().then(function (cart) {
      if (!cart) return;
      if (!slot.isConnected || slot.querySelector('.xp-dc')) return;
      slot.appendChild(buildBox(cart, { onChange: refreshPopup }));
    });
  }
  function refreshPopup() {
    getCart(true).then(function (cart) {
      if (!cart) return;
      var total = document.getElementById('cart__popup_total');
      if (total) total.innerHTML = fmtMoney(cart.total_price);
      var slot = document.querySelector('.xp-dc-slot');
      if (!slot) return;
      var old = slot.querySelector('.xp-dc');
      if (old) old.remove();
      slot.appendChild(buildBox(cart, { onChange: refreshPopup }));
    });
  }
  if (window.theme && theme.cart_status === 'show_popup') {
    new MutationObserver(function () { enhancePopup(); })
      .observe(document.body, { childList: true, subtree: true });
    enhancePopup();
  }

  /* ---------- cart page ---------- */
  // 0907 修复：/cart 页整页 reload 会把 toast + 提示一起吞掉 → reload 前把结果存进 sessionStorage，reload 后回放一次再清掉
  function cartPageReload() {
    try { sessionStorage.setItem(SS_MSG, JSON.stringify({ toast: _lastToast, msg: _lastMsg })); } catch (e) {}
    window.location.reload();
  }
  function replayCartPageMsg() {
    var raw = null;
    try { raw = sessionStorage.getItem(SS_MSG); sessionStorage.removeItem(SS_MSG); } catch (e) {}
    if (!raw) return;
    try {
      var saved = JSON.parse(raw);
      if (saved && saved.msg && saved.msg.code) _lastMsg = saved.msg;
      if (saved && saved.toast) toast(saved.toast);
    } catch (e) {}
  }
  function enhanceCartPage() {
    if (!document.body.classList.contains('template-cart')) return;
    var col = document.querySelector('.cart__layout_right .grid__item');
    if (!col || col.querySelector('.xp-dc')) return;
    replayCartPageMsg();
    getCart().then(function (cart) {
      if (!cart) { if ((window.__xpRetryC = (window.__xpRetryC || 0) + 1) <= 5) setTimeout(enhanceCartPage, 4000); return; }
      if (col.querySelector('.xp-dc')) return;
      var box = buildBox(cart, { onChange: cartPageReload });
      var total = col.querySelector('.cart__total');
      col.insertBefore(box, total || col.firstChild);
    });
  }

  /* ---------- theme's own drawer discount tab: make it live ---------- */
  document.addEventListener('click', function (e) {
    var save = e.target.closest('.btn_save--discount');
    if (!save) return;
    var wrap = save.closest('.cart_extend');
    var input = wrap && wrap.querySelector('input[name="discount"]');
    var val = input && (input.value || '').trim();
    if (!val) return;
    applyWithGuard(val).then(function (res) {
      var d = settle(val, res); // 0907 修复：统一判据与文案，无效码不持久化
      refreshDrawer();
      toast(d.text);
    }).catch(function () {
      toast('Could not apply the code — please try again.'); // 0907 修复
    });
  });

  /* ---------- PDP claim buttons ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-xp-copy]');
    if (!btn) return;
    var code = btn.getAttribute('data-xp-copy');
    copyText(code);
    if (window.__xpApplyBusy) return; // 连点保护:进行中的应用链未结束前忽略新点击
    window.__xpApplyBusy = true;
    applyWithGuard(code).then(function (res) {
      var d = settle(code, res); // 0907 修复：以「该码 applicable」为准；空车说加购后抵扣；门槛/无效给具体原因
      refreshDrawer();
      // 0907 修复：只有真正生效或空车已保存才亮 CLAIMED ✓（原来无条件亮，券没生效也显示已领取）
      if (res.applied || res.state === 'pending') {
        btn.classList.add('is-copied');
        clearTimeout(btn._xpT);
        btn._xpT = setTimeout(function () { btn.classList.remove('is-copied'); }, 3000);
      }
      toast(res.applied ? 'Coupon ' + code + ' applied — you save ' + fmtMoney(res.cart.total_discount) + '.' : d.text);
    }).then(function () { window.__xpApplyBusy = false; })
      .catch(function () {
        window.__xpApplyBusy = false;
        // 0907 修复：429/网络错误时不再写 localStorage/cookie、不报「copied」成功语气
        toast('Could not apply ' + code + ' — please try again in a moment.');
      });
  });

  /* ---------- global safety net for the theme's silent AJAX failures ---------- */
  function restoreAtcButtons() {
    document.querySelectorAll('.product-form__cart-submit .add-to-cart-text').forEach(function (el) {
      if (el.dataset.xpOrig) { if (el.textContent !== el.dataset.xpOrig) el.textContent = el.dataset.xpOrig; }
      else { try { el.textContent = (window.variantStrings && (variantStrings.addTobag || variantStrings.addToCart)) || el.textContent; } catch (e2) {} }
    });
  }
  function rememberAtcButtons() {
    document.querySelectorAll('.product-form__cart-submit .add-to-cart-text').forEach(function (el) {
      if (!el.dataset.xpOrig) el.dataset.xpOrig = el.textContent;
    });
  }
  if (window.jQuery) {
    jQuery(document).ajaxError(function (_e, xhr, settings) {
      var url = (settings && settings.url) || '';
      if (!/\/cart\/(add|change|update)\.js/.test(url)) return;
      // nuranium.js: remove/qty failures are silent; add failures mislabel as Sold out
      setTimeout(restoreAtcButtons, 50);
      if (xhr && xhr.status === 422) return; // genuine cart validation (e.g. real sold out)
      toast('Connection hiccup — cart refreshed, please try again.');
      resyncDrawer();
    });
    // cart page: any successful cart mutation (theme qty steppers etc.) must
    // refresh our discount summary — it is injected once and otherwise goes stale
    jQuery(document).ajaxComplete(function (_e, _xhr, settings) {
      var url = (settings && settings.url) || '';
      if (!/\/cart\/(change|add|update)\.js/.test(url)) return;
      if (!document.body.classList.contains('template-cart')) return;
      clearTimeout(window.__xpCartPageSync);
      window.__xpCartPageSync = setTimeout(function () {
        var col = document.querySelector('.cart__layout_right .grid__item');
        if (!col) return;
        getCart(true).then(function (cart) {
          if (!cart) return;
          var old = col.querySelector('.xp-dc');
          if (old) old.remove();
          var total = col.querySelector('.cart__total');
          col.insertBefore(buildBox(cart, { onChange: cartPageReload }), total || col.firstChild); // 0907 修复
          var sav = document.querySelector('.cart__savings-amount');
          if (sav) sav.textContent = fmtMoney(cart.total_discount);
          var subEl = document.querySelector('.cart__subtotal');
          if (subEl) subEl.innerHTML = fmtMoney(cart.total_price);
        });
      }, 700);
    });
  }

  // 主题 nuranium.js 固有缺陷的前置护栏:
  // 1) 数量手打 0 会让服务端删行而 DOM 不删(找 <tr> 而行是 div),后续行号全错位 → 捕获阶段把 <1 的值改回 1
  // 2) 'change keyup' 每键直发 change.js 无防抖 → 捕获阶段拦下 keyup,只留 change(失焦/回车)触发
  document.addEventListener('change', function (e) {
    var inp = e.target;
    if (!inp || !inp.matches || !inp.matches('.cart__qty-input, .cart__popup-qty--input')) return;
    var v = parseInt(inp.value, 10);
    if (!v || v < 1) inp.value = 1;
  }, true);
  document.addEventListener('keyup', function (e) {
    if (e.target && e.target.matches && e.target.matches('.cart__qty-input, .cart__popup-qty--input')) e.stopPropagation();
  }, true);

  function init() {
    rememberAtcButtons();
    enhanceCartPage();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


